import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolGetStartedStepFour = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-7 md:col-span-6">
          <h2 className="school-section-title h3">
            {t('service.school.gettingStarted.explanations.title.step3')}
          </h2>
          <div className="block sm:hidden my-8 sm:my-0">
            <Image
              width={575}
              height={300}
              sizes="100vw"
              style={{ width: '100%', height: 'auto' }}
              className="flex-image"
              src="/images/ogImg.png"
              alt="LingualBox Class Image"
            />
          </div>
          <p className="school-section-description">
            {t('service.school.gettingStarted.explanations.detail.step3')}
          </p>
        </div>
        <div className="order-first md:order-last col-span-12 lg:col-span-5 md:col-span-6 hidden sm:block">
          <Image
            width={575}
            height={300}
            sizes="100vw"
            style={{ width: '100%', height: 'auto' }}
            className="flex-image"
            src="/images/ogImg.png"
            alt="LingualBox Class Image"
          />
        </div>
      </div>
    </div>
  );
};

export default SchoolGetStartedStepFour;
